import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '../../components/DesignSystemV2/Typography';
import { colorsV2 } from 'style/colors-v2';
import { LinearThinkingNewsSlide } from 'components/LinearThinkingNews';
import { SectionV3 } from 'components/SectionV3';
import { ResponsiveContainer } from 'components/ResponsiveContainer';
import { BulbIcon } from 'components/Icon/SVGIcons';

const Section = styled(SectionV3)`
  background: linear-gradient(
    180deg,
    ${colorsV2.paper} 0%,
    ${colorsV2.white100} 100%
  );
`;

const NewsAboutDolWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  text-align: center;

  .rfm-initial-child-container {
    align-items: start;
  }
`;

const HeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: ${colorsV2.paper160};
  background-color: ${colorsV2.paper10};
  border: 1px solid ${colorsV2.paper60};
  padding: 10px 20px;
  border-radius: 16px;
`;

export const NewsLinearThinking = ({ data }) => {
  const { title, news } = data;
  return (
    <Section>
      <ResponsiveContainer>
        <NewsAboutDolWrapper>
          <HeadlineWrapper>
            <BulbIcon color="currentColor" />
            <Typography variant="medium/14-20" color="currentColor">
              {title}
            </Typography>
          </HeadlineWrapper>
          <LinearThinkingNewsSlide data={news} />
        </NewsAboutDolWrapper>
      </ResponsiveContainer>
    </Section>
  );
};
